import getNextConfig from 'next/config'
import type { NextBaseConfig } from '../../packages/@necktip/next/config/types'

export function getConfig() {
	return getNextConfig() as NextAppConfig & NextBaseConfig
}
